import { pgTable, uuid, timestamp, varchar, index, integer } from 'drizzle-orm/pg-core';
import { users } from '../../user/models/users';
import { consultationStatusEnum } from '../enums/consultationStatusEnum';

const schema = {
  id: uuid('id').defaultRandom().primaryKey(),
  external_id: uuid('external_id').defaultRandom().notNull().unique(),
  user_id: uuid('user_id').notNull().references(() => users.id),
  clinician_user_id: uuid('clinician_user_id').references(() => users.id),
  ehr_consultation_id: varchar('ehr_consultation_id', { length: 64 }),
  status: consultationStatusEnum('status').notNull(),
  scheduled_for: timestamp('scheduled_for', { withTimezone: true, mode: 'date' }),
  started_at: timestamp('started_at', { withTimezone: true, mode: 'date' }),
  ended_at: timestamp('ended_at', { withTimezone: true, mode: 'date' }),
  duration_minutes: integer('duration_minutes').default(30),
  last_polled_at: timestamp('last_polled_at', { withTimezone: true, mode: 'date' }),
  callback_url: varchar('callback_url', { length: 512 }),
  date_created: timestamp('date_created', { withTimezone: true, mode: 'date' }).defaultNow().notNull(),
  date_modified: timestamp('date_modified', { withTimezone: true, mode: 'date' }).defaultNow().notNull(),
}

/**
 * @ignore
 * @internal
 */
export const consultations = pgTable(
  'Consultations', 
  schema,
  (table) => [
    index('consultation_external_id_idx').on(table.external_id),
    index('consultation_user_id_idx').on(table.user_id),
    index('consultation_clinician_user_id_idx').on(table.clinician_user_id),
    index('consultation_status_idx').on(table.status),
    index('consultation_ehr_id_idx').on(table.ehr_consultation_id),
    index('consultation_scheduled_for_idx').on(table.scheduled_for),
    index('consultation_started_at_idx').on(table.started_at),
    index('consultation_last_polled_at_idx').on(table.last_polled_at),
  ]
);
